import { createClient } from '@supabase/supabase-js';

const url = String(process.env.REACT_APP_SUPABASE_URL || '').trim().replace(/\/$/, '');
const anonKey = String(process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

export const isSupabaseConfigured = Boolean(
  (/^https:\/\/[a-z0-9-]+\.supabase\.co$/i.test(url) || /^http:\/\/(localhost|127\.0\.0\.1):\d+$/.test(url)) && anonKey
);

export const supabase = isSupabaseConfigured
  ? createClient(url, anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  })
  : null;
